/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PagedGridInstancesState } from '../reducer';

export const featureSelector = createSelector(
  createFeatureSelector('grid-shared-state'),
  (state) => state['gridInstancesState'] as PagedGridInstancesState,
);

export const selectInstanceState = (instanceId: string) =>
  createSelector(featureSelector, (instancesState) => instancesState[instanceId]);

export const selectAllGridInstances = featureSelector;
